import React from "react"
import PropTypes from "prop-types"
import { Box, Flex, Link } from "rebass"
import styled from "@emotion/styled"

import theme from "../../../theme"
import RowWrapper from "../page-builder/RowWrapper"

const FootNote = (props) => {
  const {footnote, showCredits } = props

  return (
    <RowWrapper
      tag="footer"
      spacerY={4}
      spacerX={6}
      overflow="hidden"
      fluid={true}
      bg={theme.colors.text}
      textColor={theme.colors.background}
    >
      <Flex flexDirection={["column", null, "row"]} alignItems={["flex-start", null, "center"]} justifyContent="space-between" px={['15px', null, 0]}>
        <Box as="p" width={['100%', null, 'auto']} m={0} p={0} lineHeight={["heading", null, 1]} fontFamily={theme.fonts.body} fontSize={0}>{footnote}</Box>
        {showCredits &&
          <Box fontFamily={theme.fonts.heading} fontSize={0} mt={[3,0]}>
            <Link
              href='https://mill3.studio'
              title="Site fait par Mill3"
              target="_blank"
              rel="noopener"
              as={Credits}
            >
              <Box as={Author} aria-hidden="true">Mill3</Box>
              <Box as={CreditsLabel} aria-hidden="true">Crédits</Box>
            </Link>
          </Box>
        }
      </Flex>
    </RowWrapper>
  )
}

FootNote.propTypes = {
  footnote: PropTypes.string,
  showCredits: PropTypes.bool,
}

FootNote.defaultProps = {
  footnote: '',
  showCredits: false,
}

export default FootNote


// components style

const Author = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
`

const CreditsLabel = styled.span``

const Credits = styled.a`
  color: currentColor !important;
  display: block;
  margin: 0;
  padding: 0 !important;
  position: relative;
  text-decoration: none;

  & > span {
    display: block;
    pointer-events: none;
    transform: translate3d(0%, 0, 0);
    transition: opacity 250ms linear, transform 350ms cubic-bezier(0.215, 0.610, 0.355, 1.000); /* easeOutCubic */
    will-change: opacity, transform;
    white-space: nowrap;
  }

  & > ${Author} {
    transform: translate3d(-60%, 0, 0);
  }

  &:hover,
  &:focus,
  &:active {
    & > ${CreditsLabel} {
      transform: translate3d(60%, 0, 0);
      opacity: 0;
    }
    & > ${Author} {
      transform: translate3d(0%, 0, 0);
      opacity: 1;
    }
  }
`
